import { Settlement } from 'common/src/utils/types';
import { useState } from 'react';
import { updateSettlement } from 'common/src/api/settlements';
import { addHistoryComment } from '../../services/historyService';
import useUserStore from '../../../../common/src/stores/useUserStore';
import { ConfirmModal } from '../ui';

interface BlockedSettlementDialogProps {
  isOpen: boolean;
  onClose: () => void;
  settlement: Settlement | null;
  onUpdate: (id: number, isBlocked: boolean) => void;
}

export default function BlockedSettlementDialog({
  isOpen,
  onClose,
  settlement,
  onUpdate,
}: BlockedSettlementDialogProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { userProfile } = useUserStore();

  const handleToggleBlocked = async () => {
    if (!settlement || !userProfile) return;

    setIsLoading(true);
    try {
      const newIsBlocked = !settlement.is_blocked;
      await updateSettlement(settlement.id, {
        is_blocked: newIsBlocked,
      });

      // Crear la acción en el historial
      const actionMessage = `${userProfile.first_name} ${userProfile.last_name
        } ha ${newIsBlocked
          ? 'bloqueado'
          : 'desbloqueado'
        } la liquidación`;
      await addHistoryComment(
        settlement.id,
        actionMessage,
        userProfile.id,
        'action'
      );

      onUpdate(settlement.id, newIsBlocked);
      onClose();
    } catch (error) {
      console.error('Error updating settlement:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleToggleBlocked}
      title={
        settlement?.is_blocked
          ? 'Desbloquear Liquidación'
          : 'Bloquear Liquidación'
      }
      confirmLabel={settlement?.is_blocked ? 'Desbloquear' : 'Bloquear'}
      cancelLabel='Cancelar'
      isDestructive={!settlement?.is_blocked}
      isLoading={isLoading}
    >
      <p>
        {settlement?.is_blocked
          ? '¿Estás seguro que deseas desbloquear esta liquidación? Los usuarios podrán editarla nuevamente.'
          : '¿Estás seguro que deseas bloquear esta liquidación? Los usuarios no podrán editarla.'}
      </p>
    </ConfirmModal>
  );
} 